import { render } from "./App.vue?vue&type=template&id=6d17c380"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6d17c380&lang=css"

import exportComponent from "C:\\_Dev\\eclipse-workspace24\\JS_PHP_AND_Other\\VUEjs\\CKS2025\\core_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__